import { render, staticRenderFns } from "./ClientInvoiceReportList.vue?vue&type=template&id=5bfcb240&"
import script from "./ClientInvoiceReportList.vue?vue&type=script&lang=js&"
export * from "./ClientInvoiceReportList.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoiceReportList.vue?vue&type=style&index=0&id=5bfcb240&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports